import { GlobalAxios } from "./../axios/axios-config";
import { ITicketAutomationReceivedRuleInsuranceCategory } from "../models/ticket-automation-received-rule-insurance-category";
import { IInsuranceRegister } from "../models/insurance-register";

const TICKET_AUTOMATION_RECEIVED_RULES_INSURANCE_CATEGORY_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedRuleInsuranceCategory/";

const INSURANCE_REGISTER_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/InsuranceRegister/CalendarRegister";

export const createTicketAutomationReceivedRuleInsuranceCategory = (
  item: ITicketAutomationReceivedRuleInsuranceCategory
) => {
  return GlobalAxios.post(
    TICKET_AUTOMATION_RECEIVED_RULES_INSURANCE_CATEGORY_ROUTE,
    item
  );
};

export const getTicketAutomationReceivedRuleInsuranceCategoryById = (
  id: string
) => {
  return GlobalAxios.get<ITicketAutomationReceivedRuleInsuranceCategory>(
    TICKET_AUTOMATION_RECEIVED_RULES_INSURANCE_CATEGORY_ROUTE + id
  );
};

export const updateTicketAutomationReceivedRuleInsuranceCategoryById = ({
  item,
  id,
}: {
  item: ITicketAutomationReceivedRuleInsuranceCategory;
  id: string;
}) => {
  return GlobalAxios.put(
    TICKET_AUTOMATION_RECEIVED_RULES_INSURANCE_CATEGORY_ROUTE + id,
    item
  );
};

export const insuranceRegisterList = (params?: any) => {
  return GlobalAxios.get<IInsuranceRegister[]>(INSURANCE_REGISTER_ROUTE, {
    params: params,
    paramsSerializer: {
      indexes: null,
    },
  });
};
